export const designerPaths = {
    auth: 'auth',
    oidcCallback: 'auth/oidc-callback',
    oidcLogout: 'auth/oidc-logout',
    sessionExpired: 'auth/session-expired',
    process: 'process',
    processOverview: 'process-overview',
    processOverviewDetail: 'process-overview/detail',
    userManagement: 'user-management',
    teamManagement: 'team-management',
    setPassword: 'set-password',
    unauthorized: 'unauthorized'
} as const